import GaugeChart from "@/sales/components/GaugeChart";
import { formatEuro } from "@/sales/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function KPIDashboard({ kpis, loading }) {
  if (loading || !kpis) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-[220px] bg-[#142539]/60 rounded-xl" />
        ))}
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
      data-testid="kpi-grid"
    >
      <GaugeChart
        label="Total Pipeline Value"
        value={kpis.total_pipeline_value}
        max={kpis.total_pipeline_target}
        displayValue={formatEuro(kpis.total_pipeline_value)}
        sublabel={`Target ${formatEuro(kpis.total_pipeline_target)}`}
        testid="kpi-pipeline-value"
      />
      <GaugeChart
        label="Conversion Ratio"
        value={kpis.conversion_ratio}
        max={kpis.conversion_target}
        displayValue={`${kpis.conversion_ratio.toFixed(1)}%`}
        sublabel={`${kpis.deal_counts.won} won / ${kpis.deal_counts.won + kpis.deal_counts.lost} closed`}
        testid="kpi-conversion"
      />
      <GaugeChart
        label="Avg. Sales Cycle"
        value={kpis.avg_sales_cycle_days}
        max={kpis.avg_cycle_target}
        displayValue={`${kpis.avg_sales_cycle_days.toFixed(0)}d`}
        sublabel="Lower is better"
        testid="kpi-cycle"
        invert
      />
      <GaugeChart
        label="Weighted Forecast"
        value={kpis.weighted_revenue}
        max={kpis.weighted_revenue_target}
        displayValue={formatEuro(kpis.weighted_revenue)}
        sublabel="Probability × Value"
        testid="kpi-weighted"
      />
    </div>
  );
}
